export interface SettingsWidgetsRouter {
  goToDashboardSettings({ id }: { id: string }): void;
  goToBannerEdit({ id, widgetId }: { id: string; widgetId: string }): void;
  goToBannerCreate({
    id,
    side,
  }: {
    id: string;
    side: 'account' | 'company';
  }): void;
  goToCompanyDashboardPartitionsSettings(id: string, widgetId: string): void;
  goToCompanyDashboardPartitionsEmployeeSettings(
    id: string,
    widgetId: string,
  ): void;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SettingsWidgetsRouter = Symbol('SettingsWidgetsRouter');
